import { Box, Grid, Stack, Typography } from '@mui/material'
import { KomejirushiMongon } from '~/components/common/KomejirushiMongon'
import { FC } from 'react'
import { staticPath } from '~/lib/$path'
import { ZoomImageList } from '../ConnectInstagramAccount/ZoomImageList'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { StepContents } from '../ConnectInstagramAccount/Steps'
import { InnerStepper } from '../InnerStepper'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const ThirdStep: FC = () => {
  const steps: StepContents = [
    {
      label: 'Instagramのプロフィール編集画面を開く',
      content: (
        <Stack spacing={1}>
          <LinkToInfo
            href={EXTERNAL_LINKS.INSTAGRAM_PROFILE_EDIT}
            textBefore="プロアカウントに切り替えたいInstagramアカウントで"
            linkText="プロフィール編集画面"
            textAfter="を開き、下へスクロールして「プロアカウントに切り替える」をクリックします。"
          />

          <Grid container>
            <ZoomImageList
              paths={[
                staticPath.facebook_connect_steps.instagram_pro_account.step_0_webp,
                staticPath.facebook_connect_steps.instagram_pro_account.step_1_webp,
              ]}
            />
          </Grid>
        </Stack>
      ),
    },
    {
      label: 'プロアカウントに切り替えるための設定',
      content: (
        <Stack spacing={1}>
          <Typography variant="body2">
            下記画像の手順に従い、プロアカウントへの切り替え設定を行ってください。
          </Typography>
          <ZoomImageList
            paths={[
              staticPath.facebook_connect_steps.instagram_pro_account.step_2_webp,
              staticPath.facebook_connect_steps.instagram_pro_account.step_3_webp,
              staticPath.facebook_connect_steps.instagram_pro_account.step_4_webp,
              staticPath.facebook_connect_steps.instagram_pro_account.step_5_webp,
              staticPath.facebook_connect_steps.instagram_pro_account.step_6_webp,
            ]}
          />
        </Stack>
      ),
    },
    {
      label: '完了',
      content: (
        <Stack spacing={1}>
          <Typography variant="body2">以下の画面になればプロアカウントへの切り替えが完了です。</Typography>
          <ZoomImageList paths={[staticPath.facebook_connect_steps.instagram_pro_account.step_7_webp]} />
        </Stack>
      ),
    },
  ]

  return (
    <Box>
      <KomejirushiMongon
        sx={{ mb: 2 }}
        text="既にInstagramアカウントがプロアカウントの方は、「次のステップへ」からお進みください。"
      />
      <Typography>Instagramの設定からプロアカウント（ビジネスアカウント）に変更します。</Typography>
      <Typography>下記手順を参照し、プロアカウントへの切り替えを行ってください。</Typography>

      <InnerStepper steps={steps} />
    </Box>
  )
}
